<template>
  <div class="emd-application">
    <div class="emd-dropdown" ref="apps" v-click-outside="clickedOutside">
      <div class="emd-dropdown__trigger" @click="toggleApps" :class="{'_active': showApps}">
        <div class="emd-application__content">
          <i class="emd-application__icon uil uil-table"></i>
          <span class="emd-text emd-text _size_section">Shop</span>
          <i class="emd-action-button__arrow uil uil-angle-down"></i>
        </div>
      </div>
      <div class="emd-dropdown__content" :class="{'_active': showApps}">
        <div class="emd-text _color_default _type_label _size_tiny eu-ma_2">{{$t('your-apps')}}</div>
        <ul>
          <li class="emd-dropdown__content__item">
            <a class="emd-text _color_default" :href="urlDash">
              <p>Dash</p>
            </a>
          </li>
          <li class="emd-dropdown__content__item">
            <a class="emd-text _color_default" :href="urlHub">
              <p>Hub</p>
            </a>
          </li>
          <li class="emd-dropdown__content__item" v-if="merchantHasConciliation && permissionIsEnabled('finance:view')">
            <a class="emd-text _color_default" :href="urlFinance">
              <p>Finance</p>
            </a>
          </li>
        </ul>
        <div class="emd-divider _weight_light eu-mt_2 eu-mb_3"></div>
        <div class="emd-text _color_default _type_label _size_tiny eu-ma_2">{{$t('get-to-know')}}</div>
        <ul>
          <li class="emd-dropdown__content__item" v-if="!merchantHasConciliation && permissionIsEnabled('finance:view')">
            <a class="emd-text _color_default" :href="urlFinanceDemo">
              <p>
                Finance
                <span class="emd-badge _color_success">{{$t('new')}}</span>
              </p>
            </a>
          </li>
          <li v-if="componentIsEnabled('apps', 'antifraud')" class="emd-dropdown__content__item">
            <a class="emd-text _color_default" :href="urlAntifraude" target="_blank" rel="noopener noreferrer">
              <p>
                {{$t('antifraud')}}
                <span class="emd-badge _color_success">{{$t('new')}}</span>
              </p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmdApplication',
  computed: {
    merchantId () {
      return this.$store.getters.merchantData.id
    },
    merchantSummary () {
      return this.$store.getters.merchantSummary
    },
    merchantHasConciliation () {
      return this.merchantSummary && this.merchantSummary.has_conciliation
    },
    accountId () {
      return this.$store.getters.accountData.id
    },
    urlDash () {
      return `${process.env.VUE_APP_DASH_URL}/${this.merchantId}/${this.accountId}`
    },
    urlHub () {
      return `${process.env.VUE_APP_HUB_URL}?merchant_id=${this.merchantId}&account_id=${this.accountId}`
    },
    urlFinance () {
      return `${process.env.VUE_APP_FINANCE_URL}/${this.merchantId}`
    },
    urlFinanceDemo () {
      return `${process.env.VUE_APP_COMPANY_URL}/${this.merchantId}/finance`
    },
    urlAntifraude () {
      return `${process.env.VUE_APP_URL_ANTIFRAUDE}`
    }
  },
  data () {
    return {
      showApps: false
    }
  },
  methods: {
    componentIsEnabled (section, component) {
      return this.$store.getters.componentIsEnabled(section, component)
    },
    toggleApps () {
      this.showApps = !this.showApps
    },
    clickedOutside (e) {
      if (!this.$refs.apps.contains(e.target) && this.showApps) {
        this.toggleApps()
      }
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "your-apps": "Seus apps",
      "get-to-know": "Conheça",
      "shop": "Shop",
      "hub": "Hub",
      "new": "Novo",
      "antifraud": "Antifraude"
    },
    "en-US": {
      "your-apps": "Your apps",
      "get-to-know": "Get to know",
      "shop": "Shop",
      "hub": "Hub",
      "new": "New",
      "antifraud": "Anti fraud"
    }
  }
</i18n>
